import React from "react";
import {
  Backdrop,
  Box,
  Divider,
  Fade,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Typography,
} from "@mui/material";

import ArticleIcon from "@mui/icons-material/Article";
import moment from "moment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
};

const ModalProtocolsBrands = ({ open, handleClose, protocols }) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            Protocolos do despacho
          </Typography>
          <List sx={{ width: "100%" }}>
            {protocols?.length > 0 ? (
              protocols.map((protocol) => (
                <>
                  <ListItem>
                    <ListItemIcon>
                      <ArticleIcon />
                    </ListItemIcon>
                    <ListItemText>
                      <Grid container width="100%" spacing={3}>
                        <Grid item xs={3}>
                          <Typography fontWeight={600}>Número</Typography>{" "}
                          <Typography>{protocol?.numero}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography fontWeight={600}>Data</Typography>{" "}
                          <Typography>
                            {moment.utc(protocol?.data).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography fontWeight={600}>Procurador</Typography>{" "}
                          <Typography>- - -</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography fontWeight={600}>País</Typography>{" "}
                          <Typography>- - -</Typography>
                        </Grid>
                      </Grid>
                    </ListItemText>
                  </ListItem>
                  <Divider />
                </>
              ))
            ) : (
              <ListItem>Nenhum protocolo</ListItem>
            )}
          </List>
        </Box>
      </Fade>
    </Modal>
  );
};

export default React.memo(ModalProtocolsBrands);
